export function extractAccessRights(
  type: $TSFixMe,
  id: $TSFixMe,
  rawAccessRights: $TSFixMe,
) {
  return {
    type,
    id,
    canRead: rawAccessRights.can_read,
    canUpdate: rawAccessRights.can_update,
    canDelete: rawAccessRights.can_delete,
    canPermit: rawAccessRights.can_permit,
  };
}
